export enum FeatureFlag {
	EnableEsignPilet = 'enable-esign-pilet',
	DisableRightSignature = 'disable-rightsignature',
	EnablePiletForcedAuth = 'enable-pilet-forced-reauth', // enable forced reauth when session is using legacy auth token
	EnableStorageEnforcement = 'enable-storage-enforcement', // SFDMS-48 Storage enforcement for accounts that are violating storage limits
	EnableProductLedGrowth = 'enable_product_led_growth', // Enable Product led growth
	EnableUploadSignatureAfterAccountCreationDate = 'esign_enable_upload_signature_based_on_account_creation', // Enable upload signature feature after this account creation date
	EnableSignFromDashboard = 'enable_sign_from_dashboard', // Enable sign from dashboard
	EnableBulkSendDocumentTemplate = 'enable_bulk_send_document_template', // Enable bulk send for document template
	UseProgressShareFileBranding = 'use_progress_sharefile_branding', // Use Progress ShareFile branding
}
